import {KeyValuePipe} from "@angular/common";
import {ChangeDetectionStrategy, Component, computed, inject} from "@angular/core";
import {MatButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {MatTooltip} from "@angular/material/tooltip";
import {ROLE_NAMES, SecurityService} from "@menu-security";
import {TranslatePipe} from "@ngx-translate/core";
import {BreakpointsDirective} from "../../../services/directives/breakpoints.directive";
import {LayoutService, ScreenSize} from "../../../services/layout/layout.service";

@Component({
    selector: "app-role-picker",
    imports: [
        MatButton,
        MatIcon,
        TranslatePipe,
        MatMenu,
        MatMenuTrigger,
        MatMenuItem,
        KeyValuePipe,
        BreakpointsDirective,
        MatTooltip,
    ],
    templateUrl: "./role-picker.component.html",
    styleUrl: "./role-picker.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RolePickerComponent {
    protected readonly ROLE_NAMES = ROLE_NAMES;
    protected readonly ScreenSize = ScreenSize;

    protected readonly securityService = inject(SecurityService);
    protected readonly layoutService = inject(LayoutService);

    protected readonly isCloudflight = computed(() => this.securityService.isCloudflight());
}
